import React, { ChangeEvent } from 'react';
import { ContentCard } from '../../common/components/ContentCard';
import { TextContainer, TextWrapper, TextList } from './components/TextWrapper';
import { H1 } from '@increasecard/typed-components';
import styled from 'styled-components';
import { InfoIcon } from '@increasecard/icons';
import { FileDropZone, isMobile, SelectInput } from '@card/commonlib';
import { EcuadorInfoProviders, useClearingUploadScreen } from './useClearingUploadScreen';
import { SuccessMessage, SuccessMessageContainer } from './components/SuccessMessage';
import { LastParagraph } from './components/LastParagraph';
import FilesFormatModal from './components/FilesFormatModal';

const InfoProviderSelector = styled(SelectInput)`
  margin: 0 0 27px;
`;

export function ClearingUploadScreen() {
  const {
    addFiles,
    fileName,
    fileUploaded,
    infoProviderFileInfo,
    infoProviderSelected,
    setFileName,
    selectOptions,
    setInfoProviderSelected,
    showModal,
    toggleShowFilesFormatModal,
    t
  } = useClearingUploadScreen();
  const handleInfoProviderChange = (event: ChangeEvent<HTMLSelectElement>) =>
    setInfoProviderSelected(event.currentTarget.value as EcuadorInfoProviders);

  const handleOnDropAccepted = (droppedFiles: File[]) => {
    const params = {
      file: droppedFiles[0],
      infoProvider: infoProviderSelected,
      documentType: infoProviderFileInfo[infoProviderSelected].documentType,
      fileName: infoProviderFileInfo[infoProviderSelected].fileName
    };
    setFileName(droppedFiles[0].name);
    addFiles(params);
  };

  return (
    <ContentCard>
      <TextWrapper rowGap={2}>
        <TextContainer className="grid-span-desktop-7 grid-span-mobile-1">
          <H1 as="span">{t('clearings:uploadScreen:title')}</H1>
          <TextList>
            <li>{t('clearings:uploadScreen:textList:textOne')}</li>
            <li>{t('clearings:uploadScreen:textList:textTwo')}</li>
          </TextList>
          <LastParagraph>
            <InfoIcon height={20} width={20} />
            {t('clearings:uploadScreen:textList:last')}
          </LastParagraph>
        </TextContainer>
        <FileDropZone
          accept={
            infoProviderFileInfo[infoProviderSelected] &&
            infoProviderFileInfo[infoProviderSelected].extensions
          }
          bottomLink={t('clearings:uploadScreen:bottomLink')}
          className="grid-span-desktop-5 grid-span-mobile-1"
          disabled={!infoProviderSelected}
          onBottomLinkClick={toggleShowFilesFormatModal}
          onDropAccepted={handleOnDropAccepted}
          uploadCTA={
            isMobile()
              ? t('clearings:uploadScreen:selectManuallyMobile')
              : t('clearings:uploadScreen:selectManuallyDesktop')
          }
          uploadMessage={
            isMobile()
              ? t('clearings:uploadScreen:dragFilesMobile')
              : t('clearings:uploadScreen:dragFilesDesktop')
          }
        >
          <InfoProviderSelector
            label=""
            maxWidth={270}
            name="infoProviderSelector"
            onBlur={() => null}
            onChange={handleInfoProviderChange}
            options={selectOptions}
            value={infoProviderSelected}
          />
          <SuccessMessageContainer>
            {fileUploaded && <SuccessMessage>{fileName}</SuccessMessage>}
          </SuccessMessageContainer>
        </FileDropZone>
        <FilesFormatModal
          showModal={showModal}
          toggleShowFilesFormatModal={toggleShowFilesFormatModal}
          translationFunction={t}
        />
      </TextWrapper>
    </ContentCard>
  );
}
